import React from "react"
import { Box } from "@mui/material"
import { AppFormDrawer, AppFormGrid, AppFormSection } from "@components"
import { autoEuropePricingIdDrawerData, isAutoEuropePricingIdDrawerOpen, clearAutoEuropePricingIdSignals } from "Pages/AutoEuropeTool/PricingId/@signals"
import AutoEuropePricingIdFooter from "Pages/AutoEuropeTool/PricingId/@components/Footer"
import AutoEuropePricingIdOfficeField from "Pages/AutoEuropeTool/PricingId/@components/OfficeField"
import AutoEuropePricingIdMarketField from "Pages/AutoEuropeTool/PricingId/@components/MarketField"
import AutoEuropePricingIdRecordIdField from "Pages/AutoEuropeTool/PricingId/@components/PricingRecordIdField"
import AutoEuropeOptionalPricingIdField from "Pages/AutoEuropeTool/PricingId/@components/OptionalPricingIdField"

export default function AutoEuropePricingIdDrawer({ onSubmit, isLoading }) {
	return <AppFormDrawer
		icon="hashtag"
		title={autoEuropePricingIdDrawerData.value._isEditing ? "Edit Pricing ID" : "Create Pricing ID"}
		subtitle="The offices and market a pricing record applies to"
		width="40%"
		variant="persistent"
		isOpen={isAutoEuropePricingIdDrawerOpen.value}
		controller={clearAutoEuropePricingIdSignals}
		footer={<AutoEuropePricingIdFooter onSubmit={onSubmit} isLoading={isLoading}/>}
	>
		<AppFormSection icon="hashtag" title="Pricing ID">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><AutoEuropePricingIdOfficeField/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><AutoEuropePricingIdMarketField/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><AutoEuropePricingIdRecordIdField/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><AutoEuropeOptionalPricingIdField fieldKey="autoeuropeVsMetaId" label="AutoEurope vs Meta ID"/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><AutoEuropeOptionalPricingIdField fieldKey="cr8VsMetaId" label="CR8 vs Meta ID"/></Box>
			</AppFormGrid>
		</AppFormSection>
	</AppFormDrawer>
}
